import { render } from "./BaseTabItem.vue?vue&type=template&id=57d9d9c0&scoped=true"
import script from "./BaseTabItem.vue?vue&type=script&lang=js"
export * from "./BaseTabItem.vue?vue&type=script&lang=js"

import "./BaseTabItem.vue?vue&type=style&index=0&id=57d9d9c0&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-57d9d9c0"

export default script